// src/components/Header.js
import React from 'react';

const Header = ({ title }) => {
  const today = new Date().toLocaleDateString('fa-IR');

  return (
    <header className="header">
      <div className="header-title">
         <h1>{title}</h1>
      </div>
      <div className="header-info">
        <span className="date">{today}</span>
        <div className="user">
          <span className="user-icon">👤</span>
          <span>مدیر سیستم</span>
        </div>
      </div>
    </header>
  );
};

export default Header;